import { Grid,
  Layout, LegacyCard, SkeletonBodyText, SkeletonDisplayText,
} from "@shopify/polaris"
import React from "react"

export default function SkeletonDelivery() {

  return (
    <Layout>
      <Layout.Section>
        <div>
          <Grid gap={{ xs: "1rem", sm: "1rem", md: "1rem", lg: "1rem", xl: "1rem" }}>
            <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 4, xl: 4 }}>
              <LegacyCard sectioned>
                <SkeletonBodyText lines={3} />
              </LegacyCard>
            </Grid.Cell>
            <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 4, xl: 4 }}>
              <LegacyCard sectioned>
                <SkeletonBodyText lines={3} />
              </LegacyCard>
            </Grid.Cell>
            <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 4, xl: 4 }}>
              <LegacyCard sectioned>
                <SkeletonBodyText lines={3} />
              </LegacyCard>
            </Grid.Cell>
          </Grid>
        </div>
      </Layout.Section>
      <Layout.Section>
        <LegacyCard sectioned>
          <SkeletonDisplayText size="small" />
          <div className={"mt-5"} />
          <SkeletonBodyText lines={15} />
        </LegacyCard>
      </Layout.Section>
      <Layout.Section>
        <LegacyCard sectioned>
          <SkeletonDisplayText size="small" />
          <div className={"mt-5"} />
          <SkeletonBodyText lines={4} />
        </LegacyCard>
      </Layout.Section>
      <Layout.Section>
        <LegacyCard sectioned>
          <SkeletonBodyText lines={10} />
        </LegacyCard>
      </Layout.Section>

    </Layout>
  )
}
